import HeroGlow from '../components/HeroGlow';
import LineChart from '../components/LineChart';
import MetricCard from '../components/MetricCard';
import PageTitle from '../components/PageTitle';
import QuickAccessTile from '../components/QuickAccessTile';

/**
 * Preview every prop-driven primitive that lives under
 * `src/components/`. Each component renders with placeholder props so
 * the gallery never depends on the EXCEL HR demo content — that lives
 * separately at `/examples/dashboard`.
 *
 * The point of this page is to show that the same component reacts to
 * the active theme: tap a different theme on `/examples/themes` and
 * the metrics, charts, and tiles on this page will recolor through the
 * shared CSS variable layer.
 *
 * Components that are themselves "chrome" or "demos" (Sidebar,
 * Topbar, DashboardLayout, AxiSettingsPanel/AxiDarkModeToggle/
 * AxiSettingsAboutSection/AxiMobileMenuToggle) are NOT mounted here;
 * they have their own dedicated demos or live inside the dashboard.
 */
function ComponentsGallery() {
  return (
    <div className="axi-gallery">
      <header className="axi-gallery__topbar">
        <div className="axi-gallery__brand">
          <span className="axi-gallery__brand-mark" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12,3 21,12 12,21 3,12" />
            </svg>
          </span>
          <span>Axi Design · Components</span>
        </div>
      </header>
      <main className="axi-gallery__main">
        <h1 className="axi-gallery__title">Component Library</h1>
        <p className="axi-gallery__sub">
          所有 props-driven 原始组件的样本(占位数据,非业务内容)。
          颜色随当前主题变化。
        </p>

        <section className="axi-component-group">
          <h2 className="axi-component-group__title">PageTitle</h2>
          <div className="axi-component-group__row">
            <PageTitle heading="Sample heading" sub="sample subtitle · subtitle text" />
          </div>
        </section>

        <section className="axi-component-group">
          <h2 className="axi-component-group__title">MetricCard</h2>
          <div className="axi-component-group__row">
            <MetricCard label="Active users" value="128" unit="k" trend="up" trendLabel="vs last week +5%" icon="users" />
            <MetricCard label="Errors" value="3" unit="k" trend="down" trendLabel="vs last week -12%" icon="shield" />
            <MetricCard label="Latency p95" value="240" unit="ms" trend="flat" trendLabel="vs last week 0%" icon="clock" />
            <MetricCard label="Deploys today" value="14" trend="up" trendLabel="vs yesterday +6" icon="briefcase" />
          </div>
        </section>

        <section className="axi-component-group">
          <h2 className="axi-component-group__title">LineChart</h2>
          <div className="axi-component-group__row">
            <LineChart
              title="Sample signal"
              xLabels={['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7']}
              data={[120, 140, 110, 165, 150, 180, 200]}
              yMax={250}
            />
          </div>
        </section>

        <section className="axi-component-group">
          <h2 className="axi-component-group__title">QuickAccessTile</h2>
          <div className="axi-component-group__row">
            <QuickAccessTile id="sample-1" label="Sample 1" icon="document" />
            <QuickAccessTile id="sample-2" label="Sample 2" icon="user-plus" />
            <QuickAccessTile id="sample-3" label="Sample 3" icon="bar" />
            <QuickAccessTile id="sample-4" label="Sample 4" icon="document-report" />
          </div>
        </section>

        <section className="axi-component-group">
          <h2 className="axi-component-group__title">HeroGlow (decoration)</h2>
          <div
            className="axi-component-group__row"
            style={{ position: 'relative', height: 120, overflow: 'hidden' }}
          >
            <HeroGlow />
          </div>
        </section>
      </main>
    </div>
  );
}

export default ComponentsGallery;